<template>
  <span
    ref="trigger"
    class="hint-trigger"
    @mouseenter="onHoverStart"
    @mouseleave="onHoverEnd"
    @focusin="onFocusStart"
    @focusout="onFocusEnd"
  >
    <slot />

    <teleport to="body">
      <div
        v-if="tooltip"
        class="hint-tooltip"
        :style="{ top: `${tooltip.top}px`, left: `${tooltip.left}px` }"
      >
        {{ text }}
      </div>
    </teleport>
  </span>
</template>

<script>
// Teleports its tooltip to <body> and positions it via JS, so it isn't
// clipped by an ancestor's `overflow: hidden`. Hover and focus are tracked
// independently so a mouseleave doesn't dismiss a tooltip still open via
// keyboard focus (or vice versa).
export default {
  name: 'HintTrigger',

  props: {
    text: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      tooltip: null,
      hoverActive: false,
      focusActive: false,
    };
  },

  beforeUnmount() {
    this.tooltip = null;
  },

  methods: {
    show() {
      const rect = this.$refs.trigger.getBoundingClientRect();

      this.tooltip = {
        top: rect.top,
        left: rect.left + (rect.width / 2),
      };
    },

    hide() {
      this.tooltip = null;
    },

    onHoverStart() {
      this.hoverActive = true;
      this.show();
    },

    onHoverEnd() {
      this.hoverActive = false;
      if (!this.focusActive) {
        this.hide();
      }
    },

    onFocusStart() {
      this.focusActive = true;
      this.show();
    },

    onFocusEnd() {
      this.focusActive = false;
      if (!this.hoverActive) {
        this.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hint-trigger {
  display: inline-flex;
}

.hint-tooltip {
  position: fixed;
  transform: translate(-50%, -100%);
  margin-top: -6px;
  white-space: nowrap;
  background: rgba(30, 30, 40, 0.95);
  color: #fff;
  font-size: 11px;
  font-weight: 400;
  font-family: inherit;
  padding: 4px 8px;
  border-radius: 4px;
  pointer-events: none;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}
</style>
